<template>
	<div class="calendar-main-box">
		<div class="month-change">
			<div class="left-month">
				<div class="jt" @click="changeMonth(-1)"></div>
			</div>
			<div class="this-month">
				{{showMonth}}
			</div>
			<div class="right-month">
				<div class="jt" @click="changeMonth(1)"></div>
			</div>
		</div>
		<div class="top-show" v-if="lang === 'zh'">
			<div v-for="(item, index) in topList" :key="index" class="top-show-box">
				{{item}}
			</div>

		</div>
		<div class="top-show" v-else>
			<div v-for="(item, index) in enTopList" :key="index" class="top-show-box">
				{{item}}
			</div>

		</div>
		<div class="date-show">
			<div v-for="(item, index) in dateList" :key="index" class="date-show-box">
				<div v-if="item.unShow">

				</div>
				<div v-else>
					<div class="date-show-box-top" :style="{backgroundColor: item.date == today ? '#5ce' : '', color: item.date == today ? '#01009a' : ''}">
						{{$moment(item.date).format('D')}}
					</div>
					<div class="date-show-box-bottom">
						<span v-if="item.date < today || item.date > lastDay">

						</span>
						<span v-else-if="!item.open">
							{{lang == 'zh' ? '闭馆' : 'closed'}}
						</span>
						<span v-else-if="item.left_tickets_num <= 0">
							0
						</span>
						<span v-else>
							{{lang == 'zh' ? '余' : ''}}{{item.left_tickets_num}}
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		data () {
			return {
				today: "",
				lastDay: "",
				chooseMonth: "",
				showMonth: "",
				topList: ["日", "一", "二", "三", "四", "五", "六"],
				enTopList: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
				dateList: []
			}
		},
		computed: {
			lang() {
				return this.$store.state.lang
			}
		},
		mounted() {
			let that = this
			that.getToday()
		},
		methods: {
			getToday() {
				let that = this
				that.today = that.$moment().format('YYYY-MM-DD')
				that.lastDay = that.$moment().add(6, 'days').format('YYYY-MM-DD')
				that.chooseMonth = that.$moment().format('YYYY-MM')
				if(that.lang == 'zh') {
					that.showMonth = that.$moment().format('YYYY年MM月')
				} else {
					that.showMonth = that.$moment().format('MM/YYYY')
					var monthList = [
						"Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Spt", "Oct", "Nov", "Dec"
					]
					var mon = Number(that.$moment().format('MM')) - 1
					that.showMonth = monthList[mon] + ' - ' + that.$moment().format('YYYY')
				}
				that.getDateList()
			},
			changeMonth(m) {
				let that = this
				var newMonth = that.$moment(that.chooseMonth).add(m, 'month')
				that.chooseMonth = that.$moment(newMonth).format('YYYY-MM')
				if(that.lang == 'zh') {
					that.showMonth = that.$moment(newMonth).format('YYYY年MM月')
				} else {
					var monthList = [
						"Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Spt", "Oct", "Nov", "Dec"
					]
					var mon = Number(that.$moment(newMonth).format('MM')) - 1
					that.showMonth = monthList[mon] + ' - ' + that.$moment(newMonth).format('YYYY')
				}
				that.getDateList()
			},
			getDateList() {
				let that = this
				that.$http.post({
					url: '/api/ticket/getTicMonthNum',
					data: {
						ticMonth: that.chooseMonth
					}
				}).then(res => {
					if(res.code == "S200")
					that.dateList = res.data
					var first_week = Number(that.$moment(that.dateList[0].date).format('d'))
					console.log('week', first_week);
					for(var i = 0; i < first_week; i++){
						that.dateList.unshift({
							unShow: true
						})
					}
					console.log(that.dateList);
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.calendar-main-box {
		width: 100%;
		height: 100%;
		background-color: #2460a7;
		.month-change {
			height: 20px;
			width: 100%;
			background-color: #5ce;
			display: flex;
			color: #FFFFFF;
			text-align: center;
			.left-month {
				width: 30%;
				.jt {
					width: 9px;
					height: 9px;
					border-top: 2px solid #fff;
					border-left: 2px solid #fff;
					transform: rotate(-45deg);
					margin-top: 5px;
					margin-left: 40%;
					cursor: pointer;
				}
			}
			.this-month {
				width: 40%;
			}
			.right-month {
				width: 30%;
				.jt {
					width: 9px;
					height: 9px;
					border-top: 2px solid #fff;
					border-right: 2px solid #fff;
					transform: rotate(45deg);
					margin-top: 5px;
					margin-left: 40%;
					cursor: pointer;
				}
			}
		}
		.top-show {
			width: 100%;
			height: 20px;
			line-height: 20px;
			display: flex;
			.top-show-box {
				width: 14.285%;
				text-align: center;
				font-size: 10px;
				color: #5ce;
			}
		}
		.date-show {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			.date-show-box {
				width: 14.285%;
				height: 30px;
				text-align: center;
				font-size: 9px;
				.date-show-box-top {
					margin: 0 auto;
					width: 16px;
					height: 16px;
					color: #5ce;
					border-radius: 50%;
				}
				.date-show-box-bottom {
					text-align: center;
					color: #5ce;
					font-size: 7px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Calendar.vue